export default "__VITE_ASSET__4db79e24__"